import React, { Component } from 'react';

//import axios from 'axios';

import style from './bookinginfov2.module.css';

import * as utils from '../../Utils.js';

//import BackDrop from '../../components/backdrop/backdrop';
//import BackDropLoading from '../../components/backdrop/backdroploading.js';
//import TextboxWithLabel from '../../components/textboxwithlabel/textboxwithlabel';



class Bookinginfov2 extends Component {
    constructor(props) {
        //alert("HotelCrate");
        super(props);
        this.state = {
            //reservationEdit: null,
            //guestIndexEdit: null,
            guestObject: null,
            guestV: null,
            showValidate: false,
            editLoading: false
            // resultStatus: "none",
            // resultData: null,
            // ready: false,
            //dataObject: null,
            // validateObject: null,
            //loading: true,
            // companyId: this.props.match.params.id
        };
        //this.callGetData();
    }

    openFile(url) {
        //let url = baseUrl + "/DocumentFile/get/" + e;
        let windowName = "";
        window.open(url, windowName, "height=500,width=500", "_blank");
    }
    renderFile(userFileUpload) {
        let items = [];
        if (userFileUpload !== null) {
            for (let i = 0; i < userFileUpload.length; i++) {
                let file = userFileUpload[i];

                items.push(
                    <div className={style.file_item} key={i} onClick={(e) => this.openFile(file.fileUrl)}>
                        {file.fileName}
                    </div>
                );

            }
        }
        return items

    }
    openEdit(reservation, index) {

        let guestObject = {};
        guestObject.reservationId = reservation.reservationId;
        guestObject.guestIndex = index;
        guestObject.guestId = reservation.guests[index].guestId;
        guestObject.firstName = reservation.guests[index].firstName;
        guestObject.lastName = reservation.guests[index].lastName;
        guestObject.email = reservation.guests[index].email;

        let guestV = {};
        guestV.firstName = "";
        guestV.lastName = "";
        guestV.email = "";

        this.setState({
            //reservationEdit: reservation,
            //guestIndexEdit: index
            guestObject: guestObject,
            guestV: guestV,
            showValidate: false
        })
        console.log("debug open edit");
        console.log(reservation);
        console.log(index);
    }
    renderGuest(reservation) {

        let guests = reservation.guests;
        let dic = this.props.appState.dic;

        //console.log(guests);

        let items = [];

        for (let i = 0; i < guests.length; i++) {
            let guest = guests[i];

            items.push(
                <div className={style.guestArea} key={i}>
                    <div className={style.guestTitle}>
                        {dic.Guest} {i + 1}
                        {/* <div className={style.guest_edit} onClick={(e) => this.openEdit(reservation, i)}>edit</div> */}
                    </div>

                    <div className={style.guestRow}>
                        <label>{dic.name} :</label>{guest.firstName} {guest.lastName}
                    </div>
                    <div className={style.guestRow}>
                        <label>{dic.email} :</label>{guest.email}
                    </div>
                </div>
            );
        }
        return items;
    }
    renderRoom(reservationRooms) {
        let dic = this.props.appState.dic;
        let items = [];


        for (let i = 0; i < reservationRooms.length; i++) {
            let reservation = reservationRooms[i];

            let displayGuest = this.renderGuest(reservation);

            let cancelWord = "";
            let text_status = "";

            if (reservation.status === 1) text_status = "(" + dic.WaitingForPayment + ")";
            if (reservation.status === 2) text_status = "(" + dic.WaitingForApprove + ")";
            if (reservation.status === 4) text_status = "(" + dic.Confirm + ")";


            if (reservation.status === 8) cancelWord = "(" + dic.Cancel + ")";
            if (reservation.status === 9) cancelWord = "(" + dic.Cancel + ")";
            if (reservation.status === 10) cancelWord = "(" + dic.CancelBySystem + ")";
            if (reservation.status === 11) cancelWord = "(" + dic.Cancel + ")";

            if (reservation.status === 15) text_status = "(" + dic.Confirm + ")";
            if (reservation.status === 16) text_status = "(" + dic.Confirm + ")";


            //console.log(reservation);


            items.push(
                <div className={style.room_area} key={i}>
                    <div className={style.roomTitleRow}>
                        <div className={style.roomTitle_c1}>
                            {/* <label>Room1 : Standard room, Double bed (x 2 Night)</label> */}
                            <div className={style.roomTitle_c1_title}>{dic.Room} {i + 1} : {reservation.roomTypeName} (x {reservation.duration} {dic.Night}) <span>{cancelWord}</span>{text_status}</div>
                            <div className={style.roomTitle_c1_sub_title}>{dic.ReservationRef} : {reservation.reservationCode}</div>

                        </div>
                        <div className={style.roomTitle_c2}>
                            <div className={style.roomTitle_c2_total}>THB {utils.numberWithCommas(reservation.total)}</div>
                            <div className={style.roomTitle_c2_night}>THB {utils.numberWithCommas(reservation.averageRate)} /{dic.night}</div>
                        </div>
                    </div>
                    {displayGuest}
                    <div className={style.guestRow}>
                        <label>{dic.SpecialRequest} :</label>{reservation.SpecialRequest}
                    </div>
                </div>
            );
        }
        return items;
    }

    renderTrip(btrips) {
        let dic = this.props.appState.dic;
        //console.log(btrips);


        let items = [];
        // alert("test");
        for (let i = 0; i < btrips.length; i++) {
            let trip = btrips[i];
            //alert("test");

            let tax = trip.total_tax;


            //let dayInStr =   utils.stringToDayString(trip.dateIn);
            //let dayOutStr = utils.stringToDayString(trip.dateOut);


            let dateInObject = utils.stringToDayObject(trip.dateIn);
            let dateOutObject = utils.stringToDayObject(trip.dateOut);


            let displayRoom = this.renderRoom(trip.reservationRooms);


            items.push(
                <div className={style.row} key={i}>



                    <div className={style.tripTitleRow} >
                        <label>{dic.Trip}:</label>
                        {/* Booking Ref ABC1234 */}

                    </div>

                    <div className={style.row}>
                        <div className={style.tripCol1}>
                            <div className={style.numberBox}>
                                {i + 1}
                            </div>
                            <div className={style.hotelInfoBox}>
                                <div className={style.hotelInfoRow}>
                                    <label>{trip.hotelName}</label>
                                </div>
                                <div className={style.hotelInfoRow}>
                                    <label>{dic.Address}:</label>{trip.hotelAddress}
                                </div>
                                <div className={style.hotelInfoRow}>
                                    <label>{dic.Tel}:</label>{trip.hotelTel}
                                </div>
                            </div>
                        </div>

                        <div className={style.tripCol2}>
                            <div className={style.checkInBox}>
                                <div className={style.checkInRow}>
                                    <label>{dic.CheckIn}</label>
                                </div>
                                <div className={style.checkInRow}>
                                    <label></label>{dateInObject.dayName}
                                </div>
                                <div className={style.checkInRow}>
                                    <span>{dateInObject.date}</span>{dateInObject.shortMonthName} {dateInObject.year}
                                </div>

                            </div>
                            <div className={style.checkInBox}>
                                <div className={style.checkInRow}>
                                    <label>{dic.CheckOut}</label>
                                </div>
                                <div className={style.checkInRow}>
                                    <label></label>{dateOutObject.dayName}
                                </div>
                                <div className={style.checkInRow}>
                                    <span>{dateOutObject.date}</span>{dateOutObject.shortMonthName} {dateOutObject.year}
                                </div>

                            </div>

                            <div className={style.room_night}>
                                <div className={style.room_night_column}>
                                    <label>{dic.Room}</label>
                                    <span>{trip.totalRoom}</span>
                                </div>

                                <div className={style.room_night_slash}>
                                    /
                                </div>

                                <div className={style.room_night_column}>
                                    <label>{dic.Night}</label>
                                    <span>{trip.duration}</span>
                                </div>
                            </div>

                        </div>

                    </div>



                    {displayRoom}











                    <div className={style.tripSummaryBox}>
                        <div className={style.tripSummaryRow}>
                            <div className={style.tripSummaryC1}>
                                <b>{dic.TotalAmount}</b>
                            </div>
                            <div className={style.tripSummaryC2}>
                                <b>THB {utils.numberWithCommas(trip.total)}</b>
                            </div>
                        </div>
                        <div className={style.tripSummaryRow}>
                            <div className={style.tripSummaryC1}>
                                {dic.IncludedInRate}
                            </div>
                            <div className={style.tripSummaryC2}>

                            </div>
                        </div>
                        <div className={style.tripSummaryRow}>
                            <div className={style.tripSummaryC1}>
                                {dic.Taxes}
                            </div>
                            <div className={style.tripSummaryC2}>
                                THB {utils.numberWithCommas(tax)}
                            </div>
                        </div>
                        {/* <div className={style.tripSummaryRow}>
                            <div className={style.tripSummaryC1}>
                                {dic.ServiceCharge}
                            </div>
                            <div className={style.tripSummaryC2}>
                                THB 0
                            </div>
                        </div> */}
                    </div>
                </div>
            );
        }

        return items;

    }

    handleChange = (method, index, e) => {
        // if (method === "bookingid") {
        //     // let value = e.target.value;
        //     // this.setState({
        //     //     bookingIdCf: value,
        //     //     bookingIdCf_validate: ""
        //     // })
        // }
        //alert(method);

        let guestObject = { ...this.state.guestObject };
        if (method === "firstName") {
            guestObject.firstName = e.target.value;
        }
        if (method === "lastName") {
            guestObject.lastName = e.target.value;
        }
        if (method === "email") {
            guestObject.email = e.target.value;
        }

        this.setState({
            guestObject: guestObject,
            showValidate: false
        });
    }

    guestValidate() {
        let guestObject = this.state.guestObject;
        let guestV = {};
        guestV.firstName = "";
        guestV.lastName = "";
        guestV.email = "";

        let showValidate = false;

        if (guestObject.firstName === "") {
            guestV.firstName = "First Name is required.";
            showValidate = true;
        }
        if (guestObject.lastName === "") {
            guestV.lastName = "Last Name is required.";
            showValidate = true;
        }
        if (guestObject.email === "") {
            guestV.email = "Email is required.";
            showValidate = true;
        }
        this.setState({
            guestV: guestV,
            showValidate: true
        });
        return !showValidate;
    }

    callEdit() {
        //alert("call edit");
        let token = this.props.appState.userObject.Token;
        let url = process.env.REACT_APP_API_END_POINT + "/api/corp/callguestedit";
        let data = this.state.guestObject;
        utils.callPost(url, token, data, this.callEditCallBack);
        // this.setState({
        //     //resultStatus: "loading",
        //     //showCancel: false,
        // });
    }
    callEditCallBack = (res) => {
        //alert("call back");
        //console.log("debug res");
        //console.log(res);

        alert(res.Message);

        this.setState({
            guestObject: null
        })
    }



    handleClick(method) {
        //alert(method);
        if (method === "cfEdit") {
            let check = this.guestValidate();
            if (check === true) {
                this.setState({
                    editLoading: true
                });
                this.callEdit();
            }
        }
        if (method === "hideEdit") {
            this.setState({
                guestObject: null
            });
        }
    }

    render() {
        let dic = this.props.appState.dic;
        if (this.props.infoData !== null) {


            let infoData = this.props.infoData;
            //console.log(infoData);


            let bt = infoData.bookingTransaction;
            let bc = infoData.bookingContact;
            let cc = infoData.bookingCostCenter;
            let ba = infoData.bookingApprover;
            let bfs = infoData.bookingFiles;
            let btrips = infoData.bookingTrips;




            //let taxInvoice = holdData.bookingObject.taxInvoice;
            //let contactInfo = holdData.bookingObject.contactInfo;
            //let approverInfo = holdData.bookingObject.approverInfo;

            // let messageForApproval = "-";
            // if (approverInfo.message !== "") {
            //     messageForApproval = approverInfo.message;
            // }


            let displayTrip = this.renderTrip(btrips);

            let displayFile = this.renderFile(bfs);

            // WaitingForPayment = 1,
            // WaitingForApprover = 2,
            // Confirm = 4,
            // Deny = 8,
            // Cancel = 9
            let headerText = "";
            let subHeaderText = "";
            //let subHeaderText2 = "";
            let statusText = "";
            let paymentMethod = "";
            let within = "";

            if (infoData.bookingTransaction.bookingStatus === 1) {
                headerText = dic.VerifyAndMakApayment;
                subHeaderText = dic.VerifyAndMakApaymentDes;
                //subHeaderText = dic.VerifyAndMakApaymentDes2;
                statusText = dic.WaitingForPayment;

                within = dic.PaymentWithin;
            }
            if (infoData.bookingTransaction.bookingStatus === 2) {
                headerText = dic.WaitingForApprove;
                statusText = dic.WaitingForApprove;
                within = dic.ApproveWithin;
            }
            if (infoData.bookingTransaction.bookingStatus === 4) {
                headerText = dic.Confirm;
                statusText = dic.Confirm;
                within = dic.hide;
            }
            if (infoData.bookingTransaction.bookingStatus === 5) {
                headerText = dic.Amendment;
                statusText = dic.Amendment;
                within = dic.hide;
            }

            if (infoData.bookingTransaction.bookingStatus === 8) {
                headerText = dic.Bookinghasbeendeny;
                statusText = dic.Deny;
            }

            if (infoData.bookingTransaction.bookingStatus === 9) {
                headerText = dic.BookingHasBeenCancel;
                statusText = dic.Cancel;
            }

            if (infoData.bookingTransaction.bookingStatus === 10) {
                headerText = dic.BookingHasBeenCancelByOutOfTime;
                statusText = dic.Cancel;
            }

            if (infoData.bookingTransaction.bookingStatus === 11) {
                headerText = dic.BookingHasBeenCancel;
                statusText = dic.Cancel;
            }







            if (infoData.bookingTransaction.paymentMethod === "creditCard") {
                paymentMethod = dic.CreditCard;
            }
            if (infoData.bookingTransaction.paymentMethod === "payUponArrival") {
                paymentMethod = dic.PayUponArrival;
            }
            if (infoData.bookingTransaction.paymentMethod === "billing") {
                paymentMethod = dic.Billing;
            }





            let ApproveWithin = utils.stringToDateWithTime(bt.approveWithIn);
            let guestObject = this.state.guestObject;
            //let guestV = this.state.guestV;
            console.log("guestObject");
            console.log(guestObject);



            return (
                <div className={style.area}>

                    {/* {guestObject !== null &&

                        <>
                            <BackDrop show={true} onClick={this.hideModal}></BackDrop>
                            <div className={style.modal}>


                                {this.state.editLoading === true &&
                                    <BackDropLoading show={true} />
                                }


                                <div className={style.modal_title}>Edit Guest </div>
                               

                                <div className={style.modal_input}>
                                    <TextboxWithLabel label={"First Name"} method={"firstName"} name={"firstName"} showValidate={this.state.showValidate} index={1} value={guestObject.firstName} validate={guestV.firstName} handleChange={this.handleChange} />
                                </div>
                                <div className={style.modal_input}>
                                    <TextboxWithLabel label={"Last Name"} method={"lastName"} name={"lastName"} showValidate={this.state.showValidate} index={1} value={guestObject.lastName} validate={guestV.lastName} handleChange={this.handleChange} />
                                </div>
                                <div className={style.modal_input}>
                                    <TextboxWithLabel label={"Email"} method={"email"} name={"email"} showValidate={this.state.showValidate} index={1} value={guestObject.email} validate={guestV.email} handleChange={this.handleChange} />
                                </div>



                                <div className={style.modal_tool_row}>
                                    <div className={style.modal_cf_btn} onClick={(e) => this.handleClick("cfEdit")}>Confirm</div>
                                    <div className={style.modal_cc_btn} onClick={(e) => this.handleClick("hideEdit")}>Cancel</div>
                                </div>
                            </div>
                        </>

                    } */}

                    <div className={style.center}>
                        <div className={style.space20}></div>
                        <div className={style.row}>
                            <div className={style.col50}>
                                <div className={style.pageTitle}>
                                    {headerText}
                                </div>
                                <div className={style.subTitle}>
                                    {subHeaderText}
                                </div>

                                <div className={style.companyInfoArea}>
                                    <div className={style.companyInfoRow}>
                                        <label>{dic.CompanyName} :</label>{cc.companyName}
                                    </div>
                                    <div className={style.companyInfoRow}>
                                        <label>{dic.Address} :</label>{cc.address}
                                    </div>
                                    <div className={style.companyInfoRow}>
                                        <label>{dic.CostCenter} :</label>{cc.costCenter}
                                    </div>
                                    <div className={style.companyInfoRow}>
                                        <label>{dic.TaxID} :</label>{cc.taxId}
                                    </div>
                                </div>
                            </div>

                            <div className={style.col50}>
                                <div className={style.statusBox}>
                                    <div className={style.statusBoxRow}>
                                        <label>{dic.BookingID} :</label>{bt.bookingRef}
                                    </div>
                                    <div className={style.statusBoxRow}>
                                        <label>{dic.PaymentMethod} :</label>{paymentMethod}
                                    </div>
                                    <div className={style.statusBoxRow}>
                                        <label>{dic.Status} :</label>{statusText}
                                    </div>

                                    {(infoData.bookingTransaction.bookingStatus < 4) &&
                                        <div className={style.statusBoxRow}>
                                            <label>{within} :</label>{ApproveWithin}
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                        <div className={style.space10}></div>

                        {displayTrip}

                        <div className={style.row}>
                            <div className={style.infoBox}>
                                <div className={style.boxTitle}>
                                    {dic.Contact}
                                </div>

                                <div className={style.contact_inner}>
                                    <div className={style.contact_section}>
                                        <div className={style.contact_label}>
                                            {dic.name} :
                                        </div>
                                        <div className={style.contact_value}>
                                            {bc.firstName} {bc.lastName}
                                        </div>
                                    </div>

                                    <div className={style.contact_section}>
                                        <div className={style.contact_label}>
                                            {dic.email} :
                                        </div>
                                        <div className={style.contact_value}>
                                            {bc.email}
                                        </div>
                                    </div>

                                    <div className={style.contact_section}>
                                        <div className={style.contact_label}>
                                            {dic.Tel} :
                                        </div>
                                        <div className={style.contact_value}>
                                            {bc.phone}
                                        </div>
                                    </div>
                                </div>
                                <div className={style.space20}></div>


                                {(infoData.bookingTransaction.requireApprover === true) &&
                                    <>
                                        <div className={style.boxTitle}>
                                            {dic.Approval}
                                        </div>
                                        <div className={style.contact_inner}>
                                            <div className={style.contact_section}>
                                                <div className={style.contact_label}>
                                                    {dic.name} :
                                                </div>
                                                <div className={style.contact_value}>
                                                    {ba.firstName} {ba.lastName}
                                                </div>
                                            </div>
                                            <div className={style.contact_section}>
                                                <div className={style.contact_label}>
                                                    {dic.email} :
                                                </div>
                                                <div className={style.contact_value}>
                                                    {ba.email}
                                                </div>
                                            </div>
                                            <div className={style.contact_section}>
                                                <div className={style.contact_label}>
                                                    {dic.department} :
                                                </div>
                                                <div className={style.contact_value}>
                                                    {ba.department}
                                                </div>
                                            </div>
                                            <div className={style.contact_section}>
                                                <div className={style.contact_label}>
                                                    {dic.position} :
                                                </div>
                                                <div className={style.contact_value}>
                                                    {ba.position}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>

                        {(infoData.bookingTransaction.requireApprover === true) &&
                            <div className={style.row}>
                                <div className={style.infoBox}>
                                    <div className={style.infoTitleGray}>
                                        {dic.MessageForApprover}:
                                    </div>
                                    <div className={style.approvel_message}>
                                        {ba.messageToApprover}
                                    </div>
                                    <div className={style.infoTitleGray}>
                                        {dic.UploadFilesForApproval}:
                                    </div>
                                    <div className={style.file_area}>
                                        {displayFile}
                                    </div>
                                </div>
                            </div>
                        }
                        <div className={style.space20}></div>
                    </div>
                </div>
            );
        }
        else {
            return (<></>);
        }
    }
}
export default Bookinginfov2;
















// class Bookinginfov2 extends Component {
//     constructor(props) {
//         //alert("HotelCrate");
//         super(props);
//         this.state = {
//             // resultStatus: "none",
//             // resultData: null,
//             // ready: false,
//             //dataObject: null,
//             // validateObject: null,
//             //loading: true,
//             // companyId: this.props.match.params.id
//         };
//         //this.callGetData();
//     }



//     openFile(url) {
//         //let url = baseUrl + "/DocumentFile/get/" + e;
//         let windowName = "";
//         window.open(url, windowName, "height=500,width=500", "_blank");
//     }


//     renderFile(userFileUpload) {
//         let items = [];
//         if (userFileUpload !== null) {
//             for (let i = 0; i < userFileUpload.length; i++) {
//                 let file = userFileUpload[i];

//                 items.push(
//                     <div className={style.file_item} key={i} onClick={(e)=>this.openFile(file.fileUrl)}>
//                         {file.fileName}
//                     </div>
//                 );

//             }
//         }
//         return items

//     }


//     renderGuest(guests) {
//         let dic = this.props.appState.dic;

//         //console.log(guests);

//         let items = [];

//         for (let i = 0; i < guests.length; i++) {
//             let guest = guests[i];

//             items.push(
//                 <div className={style.guestArea} key={i}>
//                     <div className={style.guestTitle}>
//                         {dic.Guest} {i + 1}
//                     </div>

//                     <div className={style.guestRow}>
//                         <label>{dic.name} :</label>{guest.firstName} {guest.lastName}
//                     </div>
//                     <div className={style.guestRow}>
//                         <label>{dic.email} :</label>{guest.email}
//                     </div>
//                 </div>
//             );
//         }
//         return items;
//     }






//     renderRoom(reservationRooms) {
//         let dic = this.props.appState.dic;
//         let items = [];


//         for (let i = 0; i < reservationRooms.length; i++) {
//             let reservation = reservationRooms[i];

//             let displayGuest = this.renderGuest(reservation.guests);


//             //console.log(reservation);


//             items.push(
//                 <div className={style.room_area} key={i}>
//                     <div className={style.roomTitleRow}>
//                         <div className={style.roomTitle_c1}>
//                             {/* <label>Room1 : Standard room, Double bed (x 2 Night)</label> */}
//                             <div className={style.roomTitle_c1_title}>{dic.Room} {i + 1} : {reservation.roomTypeName} (x {reservation.duration} {dic.Night})</div>
//                             <div className={style.roomTitle_c1_sub_title}>{dic.ReservationRef} : {reservation.reservationCode}</div>

//                         </div>
//                         <div className={style.roomTitle_c2}>
//                             <div className={style.roomTitle_c2_total}>THB { utils.numberWithCommas(reservation.total)}</div>
//                             <div className={style.roomTitle_c2_night}>THB { utils.numberWithCommas(reservation.averageRate)} /{dic.night}</div>
//                         </div>
//                     </div>
//                     {displayGuest}
//                 </div>
//             );
//         }
//         return items;
//     }


//     renderTrip(btrips) {
//         let dic = this.props.appState.dic;
//         //console.log(btrips);


//         let items = [];
//         // alert("test");
//         for (let i = 0; i < btrips.length; i++) {
//             let trip = btrips[i];
//             //alert("test");

//             //let dayInStr =   utils.stringToDayString(trip.dateIn);
//             //let dayOutStr = utils.stringToDayString(trip.dateOut);


//             let dateInObject = utils.stringToDayObject(trip.dateIn);
//             let dateOutObject = utils.stringToDayObject(trip.dateOut);


//             let displayRoom = this.renderRoom(trip.reservationRooms);


//             items.push(
//                 <div className={style.row} key={i}>



//                     <div className={style.tripTitleRow} >
//                         <label>{dic.Trip}:</label>
//                         {/* Booking Ref ABC1234 */}

//                     </div>

//                     <div className={style.row}>
//                         <div className={style.tripCol1}>
//                             <div className={style.numberBox}>
//                                 {i + 1}
//                             </div>
//                             <div className={style.hotelInfoBox}>
//                                 <div className={style.hotelInfoRow}>
//                                     <label>{trip.hotelName}</label>
//                                 </div>
//                                 <div className={style.hotelInfoRow}>
//                                     <label>{dic.Address}:</label>{trip.hotelAddress}
//                                 </div>
//                                 <div className={style.hotelInfoRow}>
//                                     <label>{dic.Tel}:</label>{trip.hotelPhone}
//                                 </div>
//                             </div>
//                         </div>

//                         <div className={style.tripCol2}>
//                             <div className={style.checkInBox}>
//                                 <div className={style.checkInRow}>
//                                     <label>{dic.CheckIn}</label>
//                                 </div>
//                                 <div className={style.checkInRow}>
//                                     <label></label>{dateInObject.dayName}
//                                 </div>
//                                 <div className={style.checkInRow}>
//                                     <span>{dateInObject.date}</span>{dateInObject.shortMonthName} {dateInObject.year}
//                                 </div>

//                             </div>
//                             <div className={style.checkInBox}>
//                                 <div className={style.checkInRow}>
//                                     <label>{dic.CheckOut}</label>
//                                 </div>
//                                 <div className={style.checkInRow}>
//                                     <label></label>{dateOutObject.dayName}
//                                 </div>
//                                 <div className={style.checkInRow}>
//                                     <span>{dateOutObject.date}</span>{dateOutObject.shortMonthName} {dateOutObject.year}
//                                 </div>

//                             </div>

//                             <div className={style.room_night}>
//                                 <div className={style.room_night_column}>
//                                     <label>{dic.Room}</label>
//                                     <span>{trip.totalRoom}</span>
//                                 </div>

//                                 <div className={style.room_night_slash}>
//                                     /
//                                 </div>

//                                 <div className={style.room_night_column}>
//                                     <label>{dic.Night}</label>
//                                     <span>{trip.duration}</span>
//                                 </div>
//                             </div>

//                         </div>

//                     </div>



//                     {displayRoom}











//                     <div className={style.tripSummaryBox}>
//                         <div className={style.tripSummaryRow}>
//                             <div className={style.tripSummaryC1}>
//                                 <b>{dic.TotalAmount}</b>
//                             </div>
//                             <div className={style.tripSummaryC2}>
//                                 <b>THB { utils.numberWithCommas(trip.total)}</b>
//                             </div>
//                         </div>
//                         <div className={style.tripSummaryRow}>
//                             <div className={style.tripSummaryC1}>
//                                 {dic.IncludedInRate}
//                             </div>
//                             <div className={style.tripSummaryC2}>

//                             </div>
//                         </div>
//                         <div className={style.tripSummaryRow}>
//                             <div className={style.tripSummaryC1}>
//                                 {dic.Taxes}
//                             </div>
//                             <div className={style.tripSummaryC2}>
//                                 THB 0
//                             </div>
//                         </div>
//                         <div className={style.tripSummaryRow}>
//                             <div className={style.tripSummaryC1}>
//                                 {dic.ServiceCharge}
//                             </div>
//                             <div className={style.tripSummaryC2}>
//                                 THB 0
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             );
//         }

//         return items;

//     }



//     render() {
//         let dic = this.props.appState.dic;
//         if (this.props.infoData !== null) {


//             let infoData = this.props.infoData;
//             //console.log(infoData);


//             let bt = infoData.bookingTransaction;
//             let bc = infoData.bookingContact;
//             let cc = infoData.bookingCostCenter;
//             let ba = infoData.bookingApprover;
//             let bfs = infoData.bookingFiles;
//             let btrips = infoData.bookingTrips;




//             //let taxInvoice = holdData.bookingObject.taxInvoice;
//             //let contactInfo = holdData.bookingObject.contactInfo;
//             //let approverInfo = holdData.bookingObject.approverInfo;

//             // let messageForApproval = "-";
//             // if (approverInfo.message !== "") {
//             //     messageForApproval = approverInfo.message;
//             // }


//             let displayTrip = this.renderTrip(btrips);

//             let displayFile = this.renderFile(bfs);

//             // WaitingForPayment = 1,
//             // WaitingForApprover = 2,
//             // Confirm = 4,
//             // Deny = 8,
//             // Cancel = 9
//             let headerText = "";
//             let statusText = "";
//             let paymentMethod = "";
//             let within = "";

//             if (infoData.bookingTransaction.bookingStatus === 1) {
//                 headerText = "Waiting For Payment";
//                 statusText = "Waiting For Payment";
//                 within = "Payment within";
//             }
//             if (infoData.bookingTransaction.bookingStatus === 2) {
//                 headerText = dic.WaitingForApprove;
//                 statusText = dic.WaitingForApprove;
//                 within = "Approver within";
//             }
//             if (infoData.bookingTransaction.bookingStatus === 4) {
//                 headerText = dic.Confirm;
//                 statusText = dic.Confirm;
//                 within = "Approver within";
//             }
//             if (infoData.bookingTransaction.bookingStatus === 9) {
//                 headerText = "Booking has been cancelled";
//                 statusText = "Cancel";
//             }

//             if(infoData.bookingTransaction.paymentMethod === "creditCard"){
//                 paymentMethod = "credit card";
//             }
//             if(infoData.bookingTransaction.paymentMethod === "payUponArrival"){
//                 paymentMethod = "pay upon arrival";
//             }
//             if(infoData.bookingTransaction.paymentMethod === "billing"){
//                 paymentMethod = "billing";
//             }





//             let ApproverWithin = utils.stringToDateWithTime(bt.approverWithIn);
//             let guestObject = this.state.guestObject;
//             let guestV = this.state.guestV;
//             console.log("guestObject");
//             console.log(guestObject);

//             return (
//                 <div className={style.area}>

                   




//                     <div className={style.center}>
//                         <div className={style.space20}></div>
//                         <div className={style.row}>




//                             <div className={style.col50}>
//                                 <div className={style.pageTitle}>
//                                     {headerText}
//                                 </div>

//                                 <div className={style.companyInfoArea}>
//                                     <div className={style.companyInfoRow}>
//                                         <label>{dic.CompanyName} :</label>{cc.companyName}
//                                     </div>
//                                     <div className={style.companyInfoRow}>
//                                         <label>{dic.Address} :</label>{cc.address}
//                                     </div>
//                                     <div className={style.companyInfoRow}>
//                                         <label>{dic.CostCenter} :</label>{cc.costCenter}
//                                     </div>
//                                     <div className={style.companyInfoRow}>
//                                         <label>{dic.TaxID} :</label>{cc.taxId}
//                                     </div>
//                                 </div>

//                             </div>


//                             <div className={style.col50}>
//                                 <div className={style.statusBox}>
//                                     <div className={style.statusBoxRow}>
//                                         <label>{dic.BookingID} :</label>{bt.bookingRef}
//                                     </div>
//                                     <div className={style.statusBoxRow}>
//                                         <label>Payment :</label>{paymentMethod}
//                                     </div>
//                                     <div className={style.statusBoxRow}>
//                                         <label>{dic.Status} :</label>{statusText}
//                                     </div>
//                                     <div className={style.statusBoxRow}>
//                                         <label>{within} :</label>{ApproverWithin}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className={style.space10}></div>

//                         {displayTrip}

//                         <div className={style.row}>
//                             <div className={style.infoBox}>
//                                 <div className={style.boxTitle}>
//                                     {dic.Contact}
//                                 </div>

//                                 <div className={style.contact_inner}>
//                                     <div className={style.contact_section}>
//                                         <div className={style.contact_label}>
//                                             {dic.name} :
//                                         </div>
//                                         <div className={style.contact_value}>
//                                             {bc.firstName} {bc.lastName}
//                                         </div>
//                                     </div>

//                                     <div className={style.contact_section}>
//                                         <div className={style.contact_label}>
//                                             {dic.email} :
//                                         </div>
//                                         <div className={style.contact_value}>
//                                             {bc.email}
//                                         </div>
//                                     </div>

//                                     <div className={style.contact_section}>
//                                         <div className={style.contact_label}>
//                                             {dic.tel} :
//                                         </div>
//                                         <div className={style.contact_value}>
//                                             {bc.phone}
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className={style.space20}></div>
//                                 <div className={style.boxTitle}>
//                                     {dic.Approval}
//                                 </div>

//                                 <div className={style.contact_inner}>
//                                     <div className={style.contact_section}>
//                                         <div className={style.contact_label}>
//                                             {dic.name} :
//                                         </div>
//                                         <div className={style.contact_value}>
//                                             {ba.firstName} {ba.lastName}
//                                         </div>
//                                     </div>

//                                     <div className={style.contact_section}>
//                                         <div className={style.contact_label}>
//                                             {dic.email} :
//                                         </div>
//                                         <div className={style.contact_value}>
//                                             {ba.email}
//                                         </div>
//                                     </div>

//                                     <div className={style.contact_section}>
//                                         <div className={style.contact_label}>
//                                             {dic.department} :
//                                         </div>
//                                         <div className={style.contact_value}>
//                                             {ba.department}
//                                         </div>
//                                     </div>
//                                     <div className={style.contact_section}>
//                                         <div className={style.contact_label}>
//                                             {dic.position} :
//                                         </div>
//                                         <div className={style.contact_value}>
//                                             {ba.position}
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className={style.row}>

//                             <div className={style.infoBox}>
//                                 <div className={style.infoTitleGray}>
//                                     {dic.MessageForApprover}:
//                                 </div>

//                                 <div className={style.approvel_message}>
//                                     {ba.messageToApprover}
//                                 </div>

//                                 <div className={style.infoTitleGray}>
//                                     {dic.UploadFilesForApproval}:
//                                 </div>

//                                 <div className={style.file_area}>

//                                     {displayFile}
//                                 </div>
//                             </div>
//                         </div>
//                         <div className={style.space20}></div>
//                     </div>
//                 </div>
//             );
//         }
//         else {
//             return (<></>);
//         }




//     }
// }
// export default Bookinginfov2;